<template lang="pug">
    div#map

        canvas#canvas(ref="canvas")
</template>

<script>
import { Deck, MapView, WebMercatorViewport } from '@deck.gl/core';
import {
    GeoJsonLayer,
    BitmapLayer,
    PolygonLayer,
    IconLayer,
} from '@deck.gl/layers';
import getBasemaps from './basemaps';
import bbox from '@turf/bbox';
import iconLocaiton from '../../imgs/icon-location.png';

const ICON_MAPPING = {
    marker: { x: 0, y: 0, width: 32, height: 32, mask: true },
};

let map;

export default {
    props: {
        topQuerySelector: String,
        aoi: Object,
        product: Object,
        height: Number,
        location: Array,
    },
    data() {
        return {};
    },
    computed: {
        geojson() {
            if (!this.aoi) return null;
            return JSON.parse(this.aoi.geometry_geojson);
        },
    },
    watch: {
        aoi(v) {
            if (!v) {
                return;
            }
            const { longitude, latitude, zoom } = this.getInitState(v);
            map.setProps({
                initialViewState: {
                    longitude,
                    latitude,
                    zoom,
                    bearing: 0,
                    pitch: 0,
                },
                layers: this.getLayers(),
            });
        },
        location(v) {
            if (!v || v.length < 2) {
                return;
            }
            const [longitude, latitude, _] = v;
            map.setProps({
                initialViewState: {
                    longitude,
                    latitude,
                    zoom: 10 + Math.random() * 3,
                    bearing: 0,
                    pitch: 0,
                },
                layers: this.getLayers(),
            });
        },
        product() {
            map.setProps({
                layers: this.getLayers(),
            });
        },
        height: {
            handler(height) {
                if (map) {
                    map.setProps({
                        height,
                    });
                } else {
                    setTimeout(() => {
                        map.setProps({
                            height,
                        });
                    }, 500);
                }
            },
            immediate: true,
        },
    },
    mounted() {
        let h = this.height || 500;
        let longitude = 121.5;
        let latitude = 31.232395363869415;
        let zoom = 13;
        if (this.aoi) {
            const _state = this.getInitState(this.aoi);
            longitude = _state.longitude;
            latitude = _state.latitude;
            zoom = _state.zoom;
        }
        map = new Deck({
            canvas: this.$refs.canvas,
            width: '100%',
            height: h,
            initialViewState: {
                longitude,
                latitude,
                zoom,
                minZoom: 1,
                maxZoom: 18,
            },
            controller: true,
            views: [
                new MapView({
                    id: 'map',
                    controller: true,
                    mapStyle:
                        'https://basemaps.cartocdn.com/gl/dark-matter-nolabels-gl-style/style.json',
                }),
            ],
            layers: this.getLayers(),
        });
    },
    destroyed() {
        map = null;
    },
    methods: {
        getLayers() {
            const [minLng, minLat, maxLng, maxLat] = bbox(this.geojson);
            return [
                ...getBasemaps(),

                // this.geojson &&
                //     new GeoJsonLayer({
                //         id: 'geojson-layer',
                //         data: this.geojson,
                //         pickable: true,
                //         stroked: false,
                //         filled: true,
                //         extruded: true,
                //         pointType: 'circle',
                //         lineWidthScale: 20,
                //         lineWidthMinPixels: 2,
                //         getFillColor: [160, 160, 180, 200],
                //         getLineColor: d => colorToRGBArray(d.properties.color),
                //         getPointRadius: 100,
                //         getLineWidth: 1,
                //         getElevation: 30,
                //     }),
                this.geojson &&
                    new PolygonLayer({
                        id: 'polygon-layer',
                        data: [this.geojson],
                        pickable: true,
                        stroked: true,
                        filled: true,
                        wireframe: true,
                        lineWidthMinPixels: 1,
                        getPolygon: d => d.coordinates,
                        getElevation: 10,
                        getFillColor: [0, 0, 0, 150],
                        getLineColor: [80, 80, 80],
                        getLineWidth: 10,
                    }),

                this.product &&
                    new BitmapLayer({
                        id: 'bitmap-layer',
                        bounds: [minLng, minLat, maxLng, maxLat],
                        image: this.product.image,
                    }),
                this.location &&
                    this.location.length >= 2 &&
                    new IconLayer({
                        id: 'icon-layer',
                        data: [{}],
                        pickable: true,
                        iconAtlas: iconLocaiton,
                        iconMapping: ICON_MAPPING,
                        getIcon: d => 'marker',
                        sizeScale: 5,
                        getPosition: d => [this.location[0], this.location[1]],
                        getSize: d => 5,
                        getColor: d => [255, 0, 0, 200],
                    }),
            ];
        },
        getInitState(v) {
            if (!v) return null;
            const [minLng, minLat, maxLng, maxLat] = bbox(
                JSON.parse(v.geometry_geojson)
            );
            const { latitude, longitude, zoom } = new WebMercatorViewport({
                width: 200,
                height: 200,
            }).fitBounds(
                [
                    [minLng, minLat],
                    [maxLng, maxLat],
                ],
                { padding: 20 }
            );

            return { latitude, longitude, zoom };
        },
    },
};
</script>

<style lang="stylus" scoped>
#map
    position relative
#canvas
    border-radius 10px
</style>
